/* eslint-disable import/prefer-default-export */
import { refreshAccessToken } from "./refreshAccessTokenApi";

export async function refreshToken() {
  const userString = localStorage.getItem("currentUser");
  if (!userString) {
    return false; // No user data available
  }
  let user;
  try {
    user = JSON.parse(userString);
  } catch (e) {
    return false; // Invalid JSON in localStorage
  }
  const newAccessToken = await refreshAccessToken({
    accessToken: user.accessToken,
    body: { refreshToken: user.refreshToken },
  });

  // Check if refresh was successful (no error and status is not 401)
  if (!newAccessToken?.message?.error && newAccessToken.status !== 401) {
    user = { ...user, accessToken: newAccessToken.accessToken };
    localStorage.setItem("currentUser", JSON.stringify(user));
    return true; // Token refresh successful
  }

  return false; // Token refresh failed
}

export function logout() {
  localStorage.removeItem("currentUser");
  localStorage.removeItem("applicationId");
  localStorage.removeItem("activeStep");
  window.location.replace("/");
}
